import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { Text } from '@fluentui/react';

export function DismissToast({ toastId }) {
  toast.dismiss(toastId);
}

export function UpdateToast({ toastId, message }) {
  toast.update(toastId, {
    render: () => <div>{message}</div>
  });
}

export function ShowToast({ title, message, type, options = { position: 'top-right' }, isApplicationStatus = false, autoClose = 5000 }) {

  if (isApplicationStatus) {
    return (
      toast.info(message, {
        position: 'bottom-left',
        hideProgressBar: true,
        theme: 'dark',
        autoClose
      })
    )
  }

  if (type === "success") {
    return (
      toast.success(() => <div>
        <Text variant='mediumPlus' style={{ fontWeight: 600, color: 'black' }}>{title}</Text><br />
        <Text variant='medium'>{message}</Text>
      </div>, options)
    );
  } else if (type === 'error') {
    return (
      toast.error(() => <div>
        <Text variant='mediumPlus' style={{ fontWeight: 600, color: 'black' }}>{title}</Text><br />
        <Text variant='medium'>{message}</Text>
      </div>, options)
    );
  } else if (type === 'info') {
    return (
      toast.info(() => <div>
        <Text variant='mediumPlus' style={{ fontWeight: 600, color: 'black' }}>{title}</Text><br />
        <Text variant='medium'>{message}</Text>
      </div>, options)
    );
  }

}

ShowToast.propTypes = {
  type: PropTypes.oneOf(["success", "error", "info"]).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
}